var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-layout",
    { staticClass: "comp-preview", attrs: { "justify-center": "", wrap: "" } },
    [
      _c(
        "v-flex",
        { staticClass: "max-width-400", attrs: { xs12: "", md6: "", lg4: "" } },
        [
          _c(_vm.previewComponent, {
            tag: "component",
            attrs: {
              name: _vm.localName || "",
              colore: _vm.colorObJ || "",
              astaColor: "",
              darkTheme: _vm.darkTheme,
            },
          }),
        ],
        1
      ),
      _c(
        "v-flex",
        {
          staticClass: "max-width-100 colors-container",
          attrs: { xs12: "", md6: "", lg4: "" },
        },
        [
          _c("v-text-field", {
            staticClass: "custom-text-field",
            attrs: {
              variant: "underlined",
              label: _vm.$t("message.Nome_personalizzato"),
              hint: _vm.$t("message.Max_10_caratteri!"),
              maxlength: "10",
              clearable: "",
            },
            on: {
              "click:clear": _vm.textClear,
              keyup: _vm.hideMobileKeyboardOnReturn,
            },
            model: {
              value: _vm.localName,
              callback: function ($$v) {
                _vm.localName = $$v
              },
              expression: "localName",
            },
          }),
          _c("h3", [_vm._v(_vm._s(_vm.$t("message.Colore")))]),
          !_vm.localColor
            ? _c("h4", { staticClass: "text-center primary--text" }, [
                _vm._v(
                  " NO " +
                    _vm._s(_vm._f("upperCase")(_vm.$t("message.Colore"))) +
                    " "
                ),
              ])
            : _vm._e(),
          _c(
            "v-layout",
            { attrs: { wrap: "" } },
            _vm._l(_vm.colors, function (color) {
              return _c(
                "v-flex",
                { key: color.name, staticClass: "color-item" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "name-color text-center",
                      class: {
                        oro: color.name == "oro",
                        argento: color.name == "argento",
                        active: color.name == _vm.colorObJ.name,
                        lightborder: color.name == "nero",
                        darkborder: color.name == "bianco" || color.name == "",
                      },
                      style: { backgroundColor: color.colorCode },
                      on: {
                        click: function ($event) {
                          return _vm.selectColor(color)
                        },
                      },
                    },
                    [
                      !color.name
                        ? _c(
                            "span",
                            {
                              staticClass: "primary--text",
                              staticStyle: {
                                "line-height": "40px",
                                "font-weight": "bold",
                              },
                            },
                            [_vm._v(" NC ")]
                          )
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }